<h1 class="center">Inventaire pour la livraison du {{ commandeDetails?.date_livraison | date: 'EEEE': 'fr' }}
	{{ commandeDetails?.date_livraison | date: 'dd/MM/yyyy': 'fr'}}</h1>
<div class="container">
	<div *ngIf="loading; else commandeEditTemplate" class="flex justify-center">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #commandeEditTemplate>
		<div class="flex justify-center">
			<div class="clamp-commande">
				<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
					<mat-nested-tree-node *matTreeNodeDef="let inventaire">
						<div *ngIf="inventaire.inventaire_lignes.length > 0">
							<div class="mat-tree-node">
								<button type="button" mat-icon-button matTreeNodeToggle
									[attr.aria-label]="'Toggle ' + inventaire.lingerie.id">
									<mat-icon class="mat-icon-rtl-mirror">
										{{treeControl.isExpanded(inventaire) ? 'expand_more' : 'chevron_right'}}
									</mat-icon>
								</button>
								<div>{{inventaire.lingerie.libelle}}</div>
								<div>
									<span [ngClass]="'state-circle ' + 'state-circle-' + inventaire.statut.code"></span>
									{{ inventaire.statut.libelle }}
								</div>
							</div>
							<div [class.example-tree-invisible]="!treeControl.isExpanded(inventaire)"
								class="content-node">
								<table class="styled-table">
									<thead>
										<tr>
											<th>Article</th>
											<th *ngIf="enabledConditionnement">Conditionnement</th>
											<th *ngIf="enabledCoeff">Quantité max</th>
											<th *ngIf="!enabledCoeff">Dotation</th>
											<th>Restant</th>
											<th>Besoin</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let ligne of inventaire.inventaire_lignes">
											<td>{{ ligne.article.designation }}</td>
											<td *ngIf="enabledConditionnement">{{ getConditionnement(ligne.article) ??
												'Non Renseigné' }}</td>
											<td>{{ ligne.dotation }}</td>
											<td>
												<mat-form-field>
													<mat-label></mat-label>
													<input type="number" matInput #restant [value]="ligne.restant" min=0
														(keypress)="omit_not_number($event)" max="ligne.dotation"
														(change)="updateInventaire(ligne, $event)" #txtInput
														(keydown.enter)="txtInput.blur()" [disabled]="isValidated">
												</mat-form-field>
											</td>
											<td>{{ ligne.restant != null ? ligne.qte_commande : 'Non inventorié' }}</td>
										</tr>
									</tbody>
								</table>
								<button mat-raised-button type="button" (click)="saveInventaire(inventaire)"
									[disabled]="isValidated">
									Enregistrer
								</button>
							</div>
						</div>
					</mat-nested-tree-node>
				</mat-tree>
			</div>
		</div>
		<div class="buttons-center">
			<button mat-raised-button (click)="refuse()" color="white">Retour</button>
			<button mat-raised-button type="button" [disabled]="isValidated" (click)="openDialog()"
				hideIfNot="!ROLE_HEBERGEMENT_LINGERE">Valider</button>
		</div>
	</ng-template>
</div>
<router-outlet></router-outlet>